import { createUseStyles } from 'react-jss';
import color from 'color';

import { flex, textOverflowDots } from '@resources/mixins';
import { ThemeProps } from '@styles/theme';

export const useStyles = createUseStyles((theme: ThemeProps) => ({
    sortedDesc: {},
    tableDisabled: {},
    scrollTable: {},
    normalTable: {},
    table: {
        ...flex('column', 'space-between', ''),
        width: '100%',
        // minHeight: 'calc(100vh - 300px)',
        height: '100%',
        background: theme.colors.surface_elevated,
        //borderRadius: theme.radius,

        '&$tableDisabled': {
            pointerEvents: 'none',
        },

        '&$scrollTable':{
            background: 'transparent',
            border: 0,
        },
        '&$normalTable':{
            border: `1.5px solid ${theme.colors.grey_light}`,
        },
    },
    mainContainer: {
        width: '100%',
        height: '100%',
        minHeight: 0,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
    },
    // Card mode with pagination: the list flows with the page scroll instead
    // of nesting its own scroll area, and the heavy table chrome disappears
    // (each card carries its own border).
    tableCardFlow: {
        height: 'auto',
        '&$normalTable': {
            border: 'none',
            background: 'transparent',
        },
    },
    mainContainerCardFlow: {
        height: 'auto',
        overflow: 'visible',
    },
    // Card mode without pagination (scroll tables): keep a single bounded
    // scroll area, but drop the table chrome the same way.
    tableCardScroll: {
        '&$scrollTable': {
            border: 'none',
            background: 'transparent',
        },
    },
    header: {
        minHeight: 56,
        flex: '0 0 56px',
        display: 'flex',
        width: '100%',
        position: 'relative',
        backgroundColor: theme.colors.surface_elevated,

        '&$scrollTable':{
            border: `1px solid ${theme.colors.grey_light}`,
        },
        '&$normalTable':{
            borderBottom: `1px solid ${theme.colors.grey_light}`,
        },
    },
    loadingWrapper: {
        height: 24,
        top: '50%',
        right: theme.spacing(5),
        position: 'absolute',
        transform: 'translate(0, -50%)',
    },
    loader: {
        color: theme.colors.violet_primary,
    },
    body: {
        width: '100%',
        minHeight: 0,
        flex: 1,

        '&$scrollTable':{
            overflow: 'auto',
            border: `solid ${theme.colors.grey_light}`,
            borderWidth: '1px 1px',
            maxHeight: 'none',
        },
        '&$normalTable':{
            overflowY: 'auto',
        },
    },
    row: {
        width: '100%',
        backgroundColor: theme.colors.surface_elevated,
        borderBottom: `1px solid ${theme.colors.grey_light}`,
        flexWrap: 'wrap',
        '&.disabled': {
            textDecoration: 'line-through',
            opacity: '0.5',
        },
        '&:hover': {
            background: theme.colors.grey_background,
        },
    },
    defaultRowContent: {
        width: '100%',
        display: 'flex',
        minHeight: 56,
    },
    expandedRowContent: {
        width: '100%',
    },
    cell: {
        display: 'flex',
        alignItems: 'center',
        minWidth: 0,
        padding: `0 ${theme.spacing(2)}`,
        color: theme.colors.black,
        fontFamily: theme.font.primary,
        fontSize: 15,
        lineHeight: 1.4,
        [theme.down('tablet')]: {
            padding: `0 ${theme.spacing(1.5)}`,
            fontSize: 14,
        },
    },
    noGrow: {
        flexGrow: '0 !important',
    },
    headerCell: {
        display: 'flex',
        alignItems: 'center',
        minWidth: 0,
        height: '100%',
        padding: `0 ${theme.spacing(1)}`,
        backgroundColor: theme.colors.surface_elevated,
        color: theme.colors.grey_text,
        textAlign: 'left',
        fontSize: 15,
        fontFamily: theme.font.secondary,
        [theme.down('tablet')]: {
            fontSize: 14,
        },

        '& span': {
            width: '100%',
            padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,
            borderRadius: 1,
            ...textOverflowDots(),
        },
    },
    sortPlaceholder: {
        marginLeft: theme.spacing(2),
        color: theme.colors.grey_light,
        transform: 'scale(1, 1)',
        display: 'none !important',
    },
    sortIndicator: {
        display: 'flex',
        paddingLeft: theme.spacing(2),
    },
    sortIcon: {
        transform: 'scale(1, 1)',
        transition: 'transform .2s ease',
        color: theme.colors.violet_primary,

        '&$sortedDesc': {
            transform: 'scale(1, -1)',
        },
    },
    withSorting: {
        cursor: 'pointer',

        '&:hover svg': {
            display: 'inherit !important',
        },

        '&:hover span': {
            backgroundColor: `${color(theme.colors.violet_primary).fade(0.92)}`,
        },
    },
    ellipsis: {
        display: 'inline-block',
        // width: '100%',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    disabledEllipsis: {
        display: 'flex',
        width: '100%',
        overflow: 'visible',
        whiteSpace: 'normal',
        textOverflow: 'clip',
    },
}));
